const Colors = {
  lightTheme: {
    primary: {
      1: "#C84C0E",
      2: "#0B4B66",
      bg: "#FBEEE8",
    },
    text: {
      primary: "#363636",
      secondary: "#787878",
      disabled: "#C5C5C5",
    },
    alert: {
      error: "#B91900",
      errorbg: "#FFF5F4",
      success: "#00703C",
      successbg: "#F1FFF8",
      warning: "#9E5F00",
      warningbg: "#FFF9F0",
      info: "#0057BD",
      infobg: "#DEEFFF",
    },
    generic: {
      background: "#EEEEEE",
      divider: "#D6D5D4",
      inputBorder: "#505A5F",
    },
    paper: {
      primary: "#FFFFFF",
      secondary: "#FAFAFA",
    },
  },
};

export { Colors };
